import storage from 'store'
import { aliyunPhotoCaptchaLogin, switchAccount, logout as logoutApi } from "@/api/user/login/Login.js";
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { addAsyncRoutes } from '@/utils/routerUtil'


const user = {
  state: {
    token: '',
    accountType: '',//当前用户类型 5.自然人 13.企业
    accountId: '',
    userName: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ACCOUNT_TYPE: (state, accountType) => {
      state.accountType = accountType
    },
    SET_ACCOUNT_ID: (state, accountId) => {
      state.accountId = accountId
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
  },

  actions: {
    // 登录
    Login({ commit }, loginInfo) {
      return new Promise((resolve, reject) => {
        aliyunPhotoCaptchaLogin(loginInfo)
          .then((response) => {
            const result = response
            if (result.code == "200") {
              storage.set(ACCESS_TOKEN, result.token, 12 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              addAsyncRoutes()
            }
            resolve(result)
          }).catch(error => {
            reject(error)
          })
      })
    },

    // 切换账号
    SwitchAccount({ commit }, switchAccountInfo) {
      return new Promise((resolve, reject) => {
        switchAccount(switchAccountInfo)
          .then((response) => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    // 登出
    ClearLocalSession({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ACCOUNT_TYPE', '')
        commit('SET_ACCOUNT_ID', '')
        commit('SET_USER_NAME', '')
        storage.remove(ACCESS_TOKEN)
        resolve()
      })
    },

    Logout({ dispatch }) {
      if (!storage.get(ACCESS_TOKEN)) {
        return dispatch('ClearLocalSession')
      }
      return logoutApi()
        .then(result => {
          if (result.code == '200' || result.code == '401') {
            return dispatch('ClearLocalSession')
          }
          const error = new Error(result.msg || '退出失败')
          error.response = {
            status: Number(result.code) || 500,
            data: result
          }
          return Promise.reject(error)
        })
        .catch(error => {
          if (((error || {}).response || {}).status === 401) {
            return dispatch('ClearLocalSession')
          }
          return Promise.reject(error)
        })
    }

  }
}

export default user
